export interface IInformationCategoryStatuses {
  showInfoSurvey: boolean;
  modeType: number;
  categoryId: string;
  categoryJsonObject: any;
  openDeleteDialog: boolean;
  toggleState: boolean;
  getSelectedRTRTemplateName: string;
  getCountOfPage: string;
  getSelectedRTRResponseField: string;
  getSelectedRTRStatus: string;
  getSelectedRTRResponseField2: string;
  getSelectedRTRStatus2: string;
  getSelectedAssociateTemplateName: string;
}

export const defaultDiceSearchStateReq: IInformationCategoryStatuses = {
  showInfoSurvey: false,
  modeType: 0,
  categoryId: '',
  categoryJsonObject: '',
  openDeleteDialog: false,
  toggleState: true,
  getSelectedRTRTemplateName: '',
  getCountOfPage: '',
  getSelectedRTRResponseField: '',
  getSelectedRTRStatus: '',
  getSelectedRTRResponseField2: '',
  getSelectedRTRStatus2: '',
  getSelectedAssociateTemplateName: '',
};
